import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth.service';

/**
 * Generalized version of adminGuard. Attach allowed module via route data:
 *   { path: 'staff', canActivate: [roleGuard], data: { module: 'Staff Management' } }
 */
export const roleGuard: CanActivateFn = (route) => {
  const auth = inject(Auth);
  const router = inject(Router);

  if (!auth.isLoggedIn()) {
    router.navigate(['/login']);
    return false;
  }

  if (auth.isAdmin()) {
    return true;
  }

  const allowedModule = route.data?.['module'] as string;

  if (!allowedModule) {
    return true;
  }

  if (allowedModule === 'Planning Approval') {
    if (auth.hasModuleAccess('Projects', 'view') || auth.hasModuleAccess('Planning Approval', 'view')) {
      return true;
    }
  } else if (auth.hasModuleAccess(allowedModule, 'view')) {
    return true;
  }

  router.navigate(['/dashboard']);
  return false;
};
